module.exports = __webpack_public_path__ + "hotels-fav-icon.png?6464c959862e975b317d289c5bfcdbf4";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/hotels-fav-icon.png
// module id = 487
// module chunks = 0